import { Box } from '@mui/material';
import { CreateVideoEditionProjectButton } from './CreateVideoEditionProjectButton';

export interface FragmentVideoEditionsStandaloneCreateToolbarProps {
  fragmentId: string;
  /** When false, nothing is rendered (e.g. when the chip header already shows create). */
  visible: boolean;
  currentProjectCount: number;
}

/**
 * Create-project control shown above the list when there are no projects yet or data is still loading.
 */
export function FragmentVideoEditionsStandaloneCreateToolbar({
  fragmentId,
  visible,
  currentProjectCount,
}: FragmentVideoEditionsStandaloneCreateToolbarProps) {
  if (!visible) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        mb: 2,
      }}
    >
      <CreateVideoEditionProjectButton
        fragmentId={fragmentId}
        currentProjectCount={currentProjectCount}
      />
    </Box>
  );
}
